import React from 'react'
import { Collapsible } from '@shared/components/Molecules/Collapsible/Collapsible.component'
import { CraneChildItem } from '@shared/types/CraneTypes';
import { useTranslations } from '@shared/context/useTranslations';
import { CraneChildItemList } from '../CraneChildItemList/CraneChildItemList.components';
import S from './CraneChildItems.module.scss'

interface CraneChildItemsProps {
    items: CraneChildItem[];
}
export const CraneChildItems = ({ items }: CraneChildItemsProps) => {
    const { getTranslation} = useTranslations();
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div className={S.craneChildItems}>
            <Collapsible
                className={S.itemClosed}
                openClassName={S.itemOpen}
                title={getTranslation(`crane.child-items.title-${!isOpen ? 'open' : 'closed'}`, { count: items.length })}
                titleClassName={S.title}
                contentClassName={S.navListemWrapper}
                open={isOpen}
                onToggle={() => setIsOpen(!isOpen)}
            >
                <CraneChildItemList items={items} />
        </Collapsible>

        </div>
    );
}
